import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, Settings } from 'lucide-react';
import { motion } from 'framer-motion';
import NotificationsDropdown from './NotificationsDropdown';
import { avatarUrl } from '../utils/api';

export const TopHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed top-0 left-0 right-0 bg-zinc-950/80 backdrop-blur-xl border-b border-white/10 z-40">
      <div className="max-w-screen-2xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src={process.env.REACT_APP_LOGO_URL || "/ferraz-logo.png"} 
            alt="Ferraz Team"
            className="h-10 w-auto"
            style={{
              filter: 'invert(1) brightness(1)'
            }}
          />
          <div>
            <h1 className="font-primary font-black text-xl text-white uppercase tracking-tighter">
              Ferraz Team
            </h1>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {/* Notificações */}
          <NotificationsDropdown />

          {/* Profile - Clickable */}
          <motion.button
            onClick={() => navigate('/edit-profile')}
            className="flex items-center gap-3 hover:bg-zinc-800/50 rounded-xl p-2 -m-2 transition-colors"
            whileTap={{ scale: 0.98 }}
          >
            <div className="w-10 h-10 rounded-full overflow-hidden bg-gradient-to-br from-neon-lime to-utility-success flex items-center justify-center text-black font-black">
              {user?.avatar_v ? (
                <img src={avatarUrl(user.id, user.avatar_v)} alt={user.name} className="w-full h-full object-cover" data-testid="header-avatar" />
              ) : (
                user?.name?.[0]
              )}
            </div>
            <div className="hidden md:block text-left">
              <p className="text-white font-bold text-sm">{user?.name}</p>
              <p className="text-zinc-500 text-xs">Nível {user?.level}</p>
            </div>
            <Settings className="w-4 h-4 text-zinc-500 hidden md:block" />
          </motion.button>

          <motion.button
            onClick={onLogout}
            className="flex items-center gap-2 bg-red-500/10 hover:bg-red-500/20 text-red-500 px-4 py-2 rounded-lg transition-colors border border-red-500/20 hover:border-red-500/40"
            whileTap={{ scale: 0.95 }}
            data-testid="logout-button"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden md:inline font-bold">Sair</span>
          </motion.button>
        </div>
      </div>
    </div>
  );
};
